import { type CreativeModelFactoryConfig } from '@bynder-studio/render-web';
import { gatewayClient, createService } from './connectors/httpClient';
import type { LegacyFontFamilyDto } from 'packages/types/fonts';

export type CreativeTemplateResponse = Pick<
    CreativeModelFactoryConfig,
    'template' | 'textStyles' | 'contentProperties'
> & {
    galleryFonts: LegacyFontFamilyDto[];
    defaultRenditionProfileId?: number | null;
    _template?: unknown;
    variationSetsValues?: unknown[];
};

const httpClient = gatewayClient('/creatives');

const creativeEditorService = createService(httpClient, (client) => ({
    getCreativeTemplate(creativeId: number, lastPublish: boolean) {
        return client.get<CreativeTemplateResponse>(`/v2/${creativeId}/editor?lastPublish=${lastPublish}`);
    },

    discardCreativeTemplate(creativeId: number) {
        return client.delete(`/v2/${creativeId}`).then(({ json, status }) => {
            return { status, json };
        });
    },
}));

export default creativeEditorService;
